import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { Route, Switch } from 'react-router-dom'
// import CheckConnection from '../CheckConnection'
// import Delayed from '../Delayed'
import SideBar from '../SideBar'
import NavBar from '../NavBar'
import ListView from '../ListView'
import DispatchView from '../DispatchView'
import TermsAndConditionsView from '../TermsAndConditionsView'
import { Layout } from 'antd'

import './index.css'

const { Content } = Layout

const Home = () => (
  <Fragment>
    <Layout className="container">
      <Layout>
        <SideBar style={{ height: '100vh' }} />
        <Layout className="rightside">
          <NavBar />
          <Layout className="content" style={{ padding: '0 24px 24px' }}>
            <Content style={{ margin: 0, minHeight: 280 }}>
              <Switch>
                <Route extact path="/model/dispatch" component={DispatchView} />
                <Route extact path="/model/termsandconditions" component={TermsAndConditionsView} />
                <Route extact path="/model/:model" component={ListView} />
              </Switch>
            </Content>
          </Layout>
        </Layout>
      </Layout>
    </Layout>
    {/* <Delayed mounted={!this.props.networkStatus} unmountAfter={1000}>
      <CheckConnection />
    </Delayed> */}
  </Fragment>
)

const mapStateToProps = state => ({
  networkStatus: state.network.status
})

export default connect(mapStateToProps)(Home)


// WEBPACK FOOTER //
// ./src/containers/Home/index.js